<template>
	<v-card-title>
		{{title}}
		<v-spacer></v-spacer>
		<v-btn icon color="primary" @click="$emit('close')">
			<v-icon>mdi-close</v-icon>
		</v-btn>
	</v-card-title>
</template>

<script>
	export default{
		name: "DialogTitle", 
		props: ["title"],
		
	}
</script>

